import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Card, CardBody,
  CardTitle,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap"


import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

import { post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import Task from '../Common/Task';
import moment from "moment";
import { connect } from "react-redux"


const columns = [{
  dataField: 'slno',
  text: '#'
}, {
  dataField: 'asset.name',
  text: 'Asset',
  sort: true,
  // formatter: (row) => {
  //   console.log('row', row);
  //   return <span>{row[0].name}{(row.length > 1) && <span className="text-muted">{' +' + (row.length - 1) + ' more'}</span>}</span>;
  // },
  filter: textFilter(),
}, {
  dataField: 'ppmactivity.name',
  text: 'Activity name',
  sort: true,
  filter: textFilter(),
},
{
  dataField: 'start_date',
  text: 'Scheduled for',
  sort: true,
  filter: textFilter(),
  formatter: (cell, row, rowIndex) => moment(row.start_date).format('DD MMM YYYY') + ' - ' + moment(row.end_date).format('DD MMM YYYY'),
  filterValue: (cell, row, rowIndex) => moment(row.start_date).format('DD MMM YYYY') + ' - ' + moment(row.end_date).format('DD MMM YYYY'),
  csvFormatter: (cell, row, rowIndex) => moment(row.start_date).format('DD MMM YYYY') + ' - ' + moment(row.end_date).format('DD MMM YYYY'),
},
// {
//   dataField: 'start_date',
//   text: 'Scheduled Time',
//   sort: true,
//   filter: textFilter(),
// }, 
{
  dataField: 'ended_at',
  text: 'Done at',
  sort: true,
  filter: textFilter(),
  formatter: (row, cell) => row ? moment(row).format('DD MMM YYYY hh:mm a') : '-',
}, {
  dataField: 'user.name',
  text: 'Done by',
  sort: true,
  filter: textFilter(),
  formatter: (row, cell) => row ? (row.user ? row.user.name : '-') : '-',
},
{
  dataField: 'task_status',
  text: 'Status',
  sort: true,
  filter: textFilter(),
  formatter: (row) => {
    return <span style={{ color: row == 'completed' ? 'rgb(77, 163, 77)' : row == 'pending' ? 'rgb(217, 171, 88)' : row == 'missed' ? 'red' : '#222' }}>{row}</span>
  },
},
];

const monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const PpmDashboard = props => {

  const [isOpen, setIsOpen] = useState(false);

  const [initializing, setInitializing] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);

  const [query, setQuery] = React.useState('scheduled');

  const [taskId, setTaskId] = React.useState(null);

  const [showDropdown, setShowDropdown] = useState(false);

  const [events, setEvents] = React.useState([
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
    { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
  ]);
  const [serviceTypes, setServiceTypes] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [serviceType, setServiceType] = React.useState(null); // For hover dropdown
  const [serviceTypeId, setServiceTypeId] = React.useState(null); // For click & fetch data
  const [groupId, setGroupId] = React.useState(null); // For click & fetch data

  const [currMonth, setCurrMonth] = React.useState(moment().format('MM'));
  const [currYear, setCurrYear] = React.useState(moment().format('YYYY'));

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  // const [selectedType, setSelectedType] = useState(null);

  // Stat Tiles
  const [activeMobileUsers, setActiveMobileUsers] = React.useState('-');
  const [contract, setContract] = React.useState('-');


  const taskTypes = {
    'completed': 'Completed',
    'delayed': 'Delayed',
    'cancelled': 'Cancelled',
    'missed': 'Missed',
    'unsync': 'Unsync',
    'pending': 'Pending',
    'bounced': 'Bounced',
    'total': 'All',
  };


  const fetchData = (year, servicetype_id, group_id) => {
    if (!props.filterBlock) { return; }
    setInitializing(true);
    post(url.GET_PPM_DASHBOARD,
      {
        block_id: props.filterBlock.id,
        year: year,
        servicetype_id: servicetype_id,
        group_id: group_id,
      }).then(response => {
        console.log('RESP', response);
        if (response.status == 200) {
          let temp = [
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
          ];
          response.data.events.map(e => {
            temp[e.month - 1].total = e.total;
            temp[e.month - 1].completed = e.completed;
            temp[e.month - 1].missed = e.missed;
            temp[e.month - 1].delayd = e.delayd;
            temp[e.month - 1].pending = e.pending;
            temp[e.month - 1].upcoming = e.upcoming;
            temp[e.month - 1].cancelled = e.cancelled;
          });
          setEvents(temp);

          setServiceTypes(response.data.servicetypes);
          setGroups(response.data.groups);
          setInitializing(false);
          // setCurrMonth(month);
          setCurrYear(year);
        }
        else {
          setData(null);
          setInitializing(false);
        }
      })
      .catch(error => {
        console.log('err:', error);
        setInitializing(false);
      });
  };

  const fetchList = (month, year, status, servicetype_id, group_id) => {
    if (!props.filterBlock) { return; }
    setLoading(true);
    // console.log(lDate, type);
    post(url.GET_PPM_TASK_LIST,
      {
        month: parseInt(month) + 1,
        year: parseInt(year),
        type: status,
        block_id: props.filterBlock.id,
        servicetype_id: servicetype_id,
        group_id: group_id,
      }).then(response => {
        console.log('RESP', response);
        if (response.status == 200) {
          setData(response.data.tasks);
          setSelectedMonth(response.data.month);
          setCurrYear(response.data.year);
          setSelectedStatus(response.data.type);
          // setSelectedType(response.data.type);
          setLoading(false);
        }
        else {
          setData(null);
          setLoading(false);
        }
      })
      .catch(error => {
        console.log('err:', error);
        setLoading(false);
      });
  };

  const fetchListFrequency = (year, servicetype_id, group_id, status) => {
    if (!props.filterBlock) { return; }
    setInitializing(true);
    post(url.GET_PPM_DASHBOARD,
      {
        block_id: props.filterBlock.id,
        year: year,
        frequencytype: status,
        servicetype_id: servicetype_id,
        group_id: group_id,
      }).then(response => {
        console.log('RESP', response);
        if (response.status == 200) {
          let temp = [
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
            { total: 0, completed: 0, missed: 0, delayd: 0, pending: 0, upcoming: 0, cancelled: 0 },
          ];
          response.data.events.map(e => {
            temp[e.month - 1].total = e.total;
            temp[e.month - 1].completed = e.completed;
            temp[e.month - 1].missed = e.missed;
            temp[e.month - 1].delayd = e.delayd;
            temp[e.month - 1].pending = e.pending;
            temp[e.month - 1].upcoming = e.upcoming;
            temp[e.month - 1].cancelled = e.cancelled;
          });
          setEvents(temp);

          setServiceTypes(response.data.servicetypes);
          setGroups(response.data.groups);
          setInitializing(false);
          // setCurrMonth(month);
          setCurrYear(year);
        }
        else {
          setData(null);
          setInitializing(false);
        }
      })
      .catch(error => {
        console.log('err:', error);
        setInitializing(false);
      });
  };


  const init = async () => {
    // await fetchData(moment().format('MM'), 2022, serviceTypeId, groupId ? groupId.value : null);
    await fetchData(moment().format('YYYY'), serviceTypeId, groupId ? groupId.value : null);
  }


  React.useEffect(() => {
    if (props.filterBlock) {
      setData([]);
      setSelectedMonth(null);
      setSelectedStatus(null);
      // setSelectedType(null);
      init();
    }
  }, [props.filterBlock]);

  const displayed = query == '' ? data : data.filter(a => a.task_status == query);
  const completed = data.filter(a => a.task_status == 'completed');
  const dispGroups = serviceType ? groups.filter(g => g.servicetype_id == serviceType.value) :
    (groupId ? groups.filter(g => g.servicetype_id == groupId.servicetype_id) : []);

  const noData = <div className="text-muted py-5 text-center">
    {props.filterBlock ? ((selectedMonth && selectedStatus) ? 'No tasks to display' : 'No selection') : "Please select Property and Block"}
  </div>

  // console.log('dispGroups', dispGroups, serviceType)

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>PPM Task Summary | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <h3 className="mb-4">PPM Task Summary</h3>


          <div className="row mt-4">
            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Tasks this month</p>
                      <h4 className="mb-0">{(loading || initializing) ? '-' : data.length}</h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-calendar font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Completed Tasks</p>
                      <h4 className="mb-0">
                        {(loading || initializing) ? '-' :
                          (completed.length + '/' + ((data.length < 1) ? '0%' : (((completed.length / data.length) * 100).toFixed(0) + '%')))}
                      </h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-calendar-check font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Active Mobile Users</p>
                      <h4 className="mb-0">{activeMobileUsers}</h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-mobile-alt font-size-24"></i>
                      </span>Dashboard
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Contracts</p>
                      <h4 className="mb-0">{contract}</h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-file font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


          {serviceTypes.length > 0 &&
            <div className="my-2"
              onMouseLeave={() => { setServiceType(null); }}
            >
              <div className="dash-servicetypes">
                <button className={serviceTypeId == null ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType(null);
                  }}
                  onClick={() => {
                    setServiceTypeId(null);
                    setGroupId(null);
                    if (selectedMonth && selectedStatus) {
                      fetchList(selectedMonth, currYear, selectedStatus, null, null);
                    }
                    fetchData(currYear, null, null);
                  }}
                >
                  All
                </button>

                {serviceTypes.map((sType, sTypeIdx) => (
                  <button className={serviceTypeId == sType.value ?
                    "btn btn-primary me-2 dash-servicetype" :
                    "btn btn-outline-primary me-2 dash-servicetype"}
                    key={sTypeIdx}
                    onMouseEnter={() => { setServiceType(sType); }}
                    onClick={async () => {
                      setServiceTypeId(sType.value);
                      setGroupId(null);
                      if (selectedMonth && selectedStatus) {
                        fetchList(selectedMonth, currYear, selectedStatus, sType.value, null);
                      }
                      fetchData(currYear, sType.value, null);
                    }}
                  >
                    {sType.label}
                  </button>
                ))}

              </div>

              <div className="mt-2 mb-2 dash-servicetypes">
                {dispGroups.map((group, groupIdx) => (
                  <button
                    className={groupId ? (groupId.value == group.value ?
                      "btn btn-secondary me-2 dash-servicetype" :
                      "btn btn-outline-secondary me-2 dash-servicetype")
                      :
                      "btn btn-outline-secondary me-2 dash-servicetype"
                    }
                    key={groupIdx}
                    onClick={() => {
                      // console.log('group', group);
                      setServiceTypeId(group.servicetype_id);
                      setGroupId(group);
                      if (selectedMonth && selectedStatus) {
                        fetchList(selectedMonth, currYear, selectedStatus, group.servicetype_id, group.value);
                      }
                      fetchData(currYear, group.servicetype_id, group.value);
                    }}
                  >
                    {group.label}
                  </button>
                ))}
              </div>

              <div className="mt-2 mb-3 dash-servicetypes">
                <button className={serviceTypeId == 11 ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType("Weekly");
                  }}
                  onClick={() => {
                    setServiceTypeId(11);
                    setGroupId(null);
                    fetchListFrequency(currYear, null, null, "Weekly");
                  }}
                >
                  Weekly
                </button>
                <button className={serviceTypeId == 4 ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType("Fortnightly");
                  }}
                  onClick={() => {
                    setServiceTypeId(4);
                    setGroupId(null);
                    fetchListFrequency(currYear, null, null, "Fortnightly");
                  }}
                >
                  Fortnightly
                </button>
                <button className={serviceTypeId == 5 ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType("Monthly");
                  }}
                  onClick={() => {
                    setServiceTypeId(5);
                    setGroupId(null);
                    fetchListFrequency(currYear, null, null, "Monthly");
                  }}
                >
                  Monthly
                </button>
                <button className={serviceTypeId == 6 ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType("Bi-Monthly");
                  }}
                  onClick={() => {
                    setServiceTypeId(6);
                    setGroupId(null);
                    fetchListFrequency(currYear, null, null, "Bi-Monthly");
                  }}
                >
                  Bi-Monthly
                </button>

                <button className={serviceTypeId == 8 ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType("Quarterly");
                  }}
                  onClick={() => {
                    setServiceTypeId(8);
                    setGroupId(null);
                    fetchListFrequency(currYear, null, null, "Quarterly");
                  }}
                >
                  Quarterly
                </button>
                <button className={serviceTypeId == 9 ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType(" Half Yearly");
                  }}
                  onClick={() => {
                    setServiceTypeId(9);
                    setGroupId(null);
                    fetchListFrequency(currYear, null, null, "Half-Yearly");
                  }}
                >
                  Half Yearly
                </button>
                <button className={serviceTypeId == 10 ?
                  "btn btn-primary me-2 dash-servicetype" :
                  "btn btn-outline-primary me-2 dash-servicetype"}
                  onMouseEnter={() => {
                    setServiceType("Yearly");
                  }}
                  onClick={() => {
                    setServiceTypeId(10);
                    setGroupId(null);
                    fetchListFrequency(currYear, null, null, "Yearly");
                  }}
                >
                  Yearly
                </button>
              </div>
            </div>}

          <div className="row mt-1">
            <div className="col-md-5">
              <Card>
                <CardBody>
                  <div className="position-relative ">
                    {loading &&
                      <div className="position-absolute top-0 bottom-0 end-0 start-0 d-flex justify-content-center align-items-start pt-5 text-muted" style={{ backgroundColor: 'rgba(255,255,255,0.8)', zIndex: 99, }}>
                        Loading..
                    </div>}
                    <div className="d-flex justify-content-center align-items-center mb-4">
                      {/* <h4 className="cal-title text-center mb-4">{currYear}</h4> */}

                      <Dropdown
                        isOpen={showDropdown}
                        toggle={() => { setShowDropdown(!showDropdown); }}
                      >
                        <DropdownToggle
                          tag="button"
                          className="btn btn-light"
                        >
                          {currYear} <i className="mdi mdi-chevron-down"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => { fetchData(2021, serviceTypeId, groupId ? groupId.value : null); }}>2021</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2022, serviceTypeId, groupId ? groupId.value : null); }}>2022</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2023, serviceTypeId, groupId ? groupId.value : null); }}>2023</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2024, serviceTypeId, groupId ? groupId.value : null); }}>2024</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2025, serviceTypeId, groupId ? groupId.value : null); }}>2025</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2026, serviceTypeId, groupId ? groupId.value : null); }}>2026</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2027, serviceTypeId, groupId ? groupId.value : null); }}>2027</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2028, serviceTypeId, groupId ? groupId.value : null); }}>2028</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2029, serviceTypeId, groupId ? groupId.value : null); }}>2029</DropdownItem>
                          <DropdownItem onClick={() => { fetchData(2030, serviceTypeId, groupId ? groupId.value : null); }}>2030</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>

                    </div>
                    {events.length == 12 &&
                      <div className="">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="flex-3">&nbsp;</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Jan</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Feb</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Mar</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Apr</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">May</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Jun</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Jul</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Aug</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Sep</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Oct</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Nov</div>
                          <div className="text-muted text-center py-2 m-1 flex-1">Dec</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-end align-items-center py-2 m-1 flex-3 text-right fw-medium">Scheduled</div>
                          <div
                            className={events[0].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[0].total > 0) {
                                fetchList(0, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[0].total}</div>
                          <div
                            className={events[1].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[1].total > 0) {
                                fetchList(1, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[1].total}</div>
                          <div
                            className={events[2].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[2].total > 0) {
                                fetchList(2, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[2].total}</div>
                          <div
                            className={events[3].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[3].total > 0) {
                                fetchList(3, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[3].total}</div>
                          <div
                            className={events[4].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[4].total > 0) {
                                fetchList(4, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[4].total}</div>
                          <div
                            className={events[5].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[5].total > 0) {
                                fetchList(5, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[5].total}</div>
                          <div
                            className={events[6].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[6].total > 0) {
                                fetchList(6, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[6].total}</div>
                          <div
                            className={events[7].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[7].total > 0) {
                                fetchList(7, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[7].total}</div>
                          <div
                            className={events[8].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[8].total > 0) {
                                fetchList(8, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[8].total}</div>
                          <div
                            className={events[9].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[9].total > 0) {
                                fetchList(9, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[9].total}</div>
                          <div
                            className={events[10].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[10].total > 0) {
                                fetchList(10, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[10].total}</div>
                          <div
                            className={events[11].total > 0 ? "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-total bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[11].total > 0) {
                                fetchList(11, currYear, 'total', serviceTypeId, groupId);
                              }
                            }}
                          >{events[11].total}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-end align-items-center py-2 m-1 flex-3 text-right fw-medium">Completed</div>
                          <div
                            className={events[0].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[0].completed > 0) {
                                fetchList(0, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[0].completed}</div>
                          <div
                            className={events[1].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[1].completed > 0) {
                                fetchList(1, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[1].completed}</div>
                          <div
                            className={events[2].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[2].completed > 0) {
                                fetchList(2, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[2].completed}</div>
                          <div
                            className={events[3].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[3].completed > 0) {
                                fetchList(3, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[3].completed}</div>
                          <div
                            className={events[4].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[4].completed > 0) {
                                fetchList(4, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[4].completed}</div>
                          <div
                            className={events[5].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[5].completed > 0) {
                                fetchList(5, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[5].completed}</div>
                          <div
                            className={events[6].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[6].completed > 0) {
                                fetchList(6, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[6].completed}</div>
                          <div
                            className={events[7].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[7].completed > 0) {
                                fetchList(7, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[7].completed}</div>
                          <div
                            className={events[8].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[8].completed > 0) {
                                fetchList(8, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[8].completed}</div>
                          <div
                            className={events[9].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[9].completed > 0) {
                                fetchList(9, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[9].completed}</div>
                          <div
                            className={events[10].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[10].completed > 0) {
                                fetchList(10, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[10].completed}</div>
                          <div
                            className={events[11].completed > 0 ? "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-completed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[11].completed > 0) {
                                fetchList(11, currYear, 'completed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[11].completed}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-end align-items-center py-2 m-1 flex-3 text-right fw-medium">Missed</div>
                          <div
                            className={events[0].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[0].missed > 0) {
                                fetchList(0, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[0].missed}</div>
                          <div
                            className={events[1].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[1].missed > 0) {
                                fetchList(1, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[1].missed}</div>
                          <div
                            className={events[2].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[2].missed > 0) {
                                fetchList(2, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[2].missed}</div>
                          <div
                            className={events[3].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[3].missed > 0) {
                                fetchList(3, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[3].missed}</div>
                          <div
                            className={events[4].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[4].missed > 0) {
                                fetchList(4, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[4].missed}</div>
                          <div
                            className={events[5].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[5].missed > 0) {
                                fetchList(5, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[5].missed}</div>
                          <div
                            className={events[6].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[6].missed > 0) {
                                fetchList(6, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[6].missed}</div>
                          <div
                            className={events[7].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[7].missed > 0) {
                                fetchList(7, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[7].missed}</div>
                          <div
                            className={events[8].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[8].missed > 0) {
                                fetchList(8, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[8].missed}</div>
                          <div
                            className={events[9].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[9].missed > 0) {
                                fetchList(9, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[9].missed}</div>
                          <div
                            className={events[10].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[10].missed > 0) {
                                fetchList(10, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[10].missed}</div>
                          <div
                            className={events[11].missed > 0 ? "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-missed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[11].missed > 0) {
                                fetchList(11, currYear, 'missed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[11].missed}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-end align-items-center py-2 m-1 flex-3 text-right fw-medium">Delayed</div>
                          <div
                            className={events[0].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[0].delayd > 0) {
                                fetchList(0, currYear, 'delayd', serviceTypeId, groupId);
                              }
                            }}
                          >{events[0].delayd}</div>
                          <div
                            className={events[1].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[1].delayd > 0) {
                                fetchList(1, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[1].delayd}</div>
                          <div
                            className={events[2].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[2].delayd > 0) {
                                fetchList(2, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[2].delayd}</div>
                          <div
                            className={events[3].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[3].delayd > 0) {
                                fetchList(3, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[3].delayd}</div>
                          <div
                            className={events[4].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[4].delayd > 0) {
                                fetchList(4, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[4].delayd}</div>
                          <div
                            className={events[5].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[5].delayd > 0) {
                                fetchList(5, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[5].delayd}</div>
                          <div
                            className={events[6].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[6].delayd > 0) {
                                fetchList(6, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[6].delayd}</div>
                          <div
                            className={events[7].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[7].delayd > 0) {
                                fetchList(7, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[7].delayd}</div>
                          <div
                            className={events[8].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[8].delayd > 0) {
                                fetchList(8, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[8].delayd}</div>
                          <div
                            className={events[9].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[9].delayd > 0) {
                                fetchList(9, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[9].delayd}</div>
                          <div
                            className={events[10].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[10].delayd > 0) {
                                fetchList(10, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[10].delayd}</div>
                          <div
                            className={events[11].delayd > 0 ? "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-delayed bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[11].delayd > 0) {
                                fetchList(11, currYear, 'delayed', serviceTypeId, groupId);
                              }
                            }}
                          >{events[11].delayd}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-end align-items-center py-2 m-1 flex-3 text-right fw-medium">Pending</div>
                          <div
                            className={events[0].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[0].pending > 0) {
                                fetchList(0, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[0].pending}</div>
                          <div
                            className={events[1].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[1].pending > 0) {
                                fetchList(1, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[1].pending}</div>
                          <div
                            className={events[2].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[2].pending > 0) {
                                fetchList(2, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[2].pending}</div>
                          <div
                            className={events[3].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[3].pending > 0) {
                                fetchList(3, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[3].pending}</div>
                          <div
                            className={events[4].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[4].pending > 0) {
                                fetchList(4, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[4].pending}</div>
                          <div
                            className={events[5].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[5].pending > 0) {
                                fetchList(5, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[5].pending}</div>
                          <div
                            className={events[6].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[6].pending > 0) {
                                fetchList(6, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[6].pending}</div>
                          <div
                            className={events[7].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[7].pending > 0) {
                                fetchList(7, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[7].pending}</div>
                          <div
                            className={events[8].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[8].pending > 0) {
                                fetchList(8, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[8].pending}</div>
                          <div
                            className={events[9].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[9].pending > 0) {
                                fetchList(9, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[9].pending}</div>
                          <div
                            className={events[10].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[10].pending > 0) {
                                fetchList(10, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[10].pending}</div>
                          <div
                            className={events[11].pending > 0 ? "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-pending bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[11].pending > 0) {
                                fetchList(11, currYear, 'pending', serviceTypeId, groupId);
                              }
                            }}
                          >{events[11].pending}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-end align-items-center py-2 m-1 flex-3 text-right fw-medium">Upcoming</div>
                          <div
                            className={events[0].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[0].upcoming > 0) {
                                fetchList(0, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[0].upcoming}</div>
                          <div
                            className={events[1].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[1].upcoming > 0) {
                                fetchList(1, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[1].upcoming}</div>
                          <div
                            className={events[2].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[2].upcoming > 0) {
                                fetchList(2, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[2].upcoming}</div>
                          <div
                            className={events[3].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[3].upcoming > 0) {
                                fetchList(3, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[3].upcoming}</div>
                          <div
                            className={events[4].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[4].upcoming > 0) {
                                fetchList(4, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[4].upcoming}</div>
                          <div
                            className={events[5].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[5].upcoming > 0) {
                                fetchList(5, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[5].upcoming}</div>
                          <div
                            className={events[6].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[6].upcoming > 0) {
                                fetchList(6, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[6].upcoming}</div>
                          <div
                            className={events[7].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[7].upcoming > 0) {
                                fetchList(7, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[7].upcoming}</div>
                          <div
                            className={events[8].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[8].upcoming > 0) {
                                fetchList(8, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[8].upcoming}</div>
                          <div
                            className={events[9].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[9].upcoming > 0) {
                                fetchList(9, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[9].upcoming}</div>
                          <div
                            className={events[10].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[10].upcoming > 0) {
                                fetchList(10, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[10].upcoming}</div>
                          <div
                            className={events[11].upcoming > 0 ? "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-upcoming bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[11].upcoming > 0) {
                                fetchList(11, currYear, 'upcoming', serviceTypeId, groupId);
                              }
                            }}
                          >{events[11].upcoming}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-end align-items-center py-2 m-1 flex-3 text-right fw-medium">Cancelled</div>
                          <div
                            className={events[0].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[0].cancelled > 0) {
                                fetchList(0, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[0].cancelled}</div>
                          <div
                            className={events[1].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[1].cancelled > 0) {
                                fetchList(1, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[1].cancelled}</div>
                          <div
                            className={events[2].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[2].cancelled > 0) {
                                fetchList(2, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[2].cancelled}</div>
                          <div
                            className={events[3].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[3].cancelled > 0) {
                                fetchList(3, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[3].cancelled}</div>
                          <div
                            className={events[4].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[4].cancelled > 0) {
                                fetchList(4, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[4].cancelled}</div>
                          <div
                            className={events[5].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[5].cancelled > 0) {
                                fetchList(5, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[5].cancelled}</div>
                          <div
                            className={events[6].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[6].cancelled > 0) {
                                fetchList(6, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[6].cancelled}</div>
                          <div
                            className={events[7].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[7].cancelled > 0) {
                                fetchList(7, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[7].cancelled}</div>
                          <div
                            className={events[8].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[8].cancelled > 0) {
                                fetchList(8, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[8].cancelled}</div>
                          <div
                            className={events[9].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[9].cancelled > 0) {
                                fetchList(9, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[9].cancelled}</div>
                          <div
                            className={events[10].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[10].cancelled > 0) {
                                fetchList(10, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[10].cancelled}</div>
                          <div
                            className={events[11].cancelled > 0 ? "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 cursor-pointer" : "rounded task-cancelled bg-gradient text-white text-center py-2 m-1 flex-1 opacity-50"}
                            onClick={() => {
                              if (events[11].cancelled > 0) {
                                fetchList(11, currYear, 'cancelled', serviceTypeId, groupId);
                              }
                            }}
                          >{events[11].cancelled}</div>
                        </div>
                      </div>}
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-md-7 ">
              <Card>
                <CardBody className="dashboard-tasks-pane">
                  {/* <CardTitle tag="h3" className="mb-2">
                    {(props.filterProperty && props.filterBlock) ? 
                      props.filterProperty.name+' / '+props.filterBlock.name :
                      '-'
                    }
                  </CardTitle> */}
                  {/* <CardSubtitle tag="h5" className="mb-4 text-muted">
                    {selectedDate ? moment(selectedDate).format('DD MMM YYYY')+(selectedType && '- '+taskTypes[selectedType]+' tasks') : 'No date selected'}
                  </CardSubtitle> */}
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <h5 className="h5">
                      PPM Tasks <span style={{ textTransform: 'capitalize' }}>
                        {selectedStatus && '- ' + (selectedStatus == 'total' ? 'All tasks' : selectedStatus)}</span>
                    </h5>
                    <h5 className="h5" style={{ color: '#919191' }}>
                      {(props.filterProperty && props.filterBlock) ?
                        props.filterProperty.name + ' / ' + props.filterBlock.name :
                        '-'
                      }
                    </h5>
                  </div>
                  <div className="mt-4">
                    <BootstrapTable
                      hover
                      className="table-tasks-dashboard"
                      keyField='id' data={data} columns={columns} filter={filterFactory()} pagination={paginationFactory()}
                      rowEvents={{
                        onClick: (e, row, rowIndex) => {
                          setTaskId(row.id);
                        }
                      }}
                      noDataIndication={noData}
                      loading={loading}
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </Container>

        {taskId !== null &&
          <Task mode="ppm" id={taskId} setTaskId={setTaskId} />}

      </div>


    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty,
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(PpmDashboard)